(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["create-your-blend-luke"]) return;
  try {
    

Shopify.moveAlong = function () {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      // pass the properties into addItem as well
      Shopify.addItem(request.v_id, request.qty, request.shipping_frequency, request.shipping_unit, request.s_id, Shopify.moveAlong);
  }
  // If the queue is empty, we will redirect to the cart page.
  else {
      document.location.href = '/cart';
  }
};

// Create a new Shopify.addItem function that takes the 'properties' parameter
Shopify.addItem = function (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id, callback) {
  var params = {
    "quantity": quantity,
    "id": variant_id,
    "properties[shipping_interval_frequency]": shipping_interval_frequency,
    "properties[shipping_interval_unit_type]": shipping_interval_unit_type,
    "properties[subscription_id]": subscription_id
  };
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function () {
      if (typeof callback === 'function') {
        callback();
      }
    },
    error: function () {}
  });
}

function push_to_queue(v_id, qty, shipping_frequency, shipping_unit, s_id) {
  Shopify.queue.push({
    v_id: v_id,
    qty: qty,
    shipping_frequency: shipping_frequency,
    shipping_unit: shipping_unit,
    s_id: s_id
  });
}

function redraw_product_images(){
  //update product images
  $('#selected-products').empty();
  var imgSrc = imgSrc,
    qtyArray = [0,0,0,0],
    imgSrcArray = ['','','',''];

    $('.option-quantity').each(function(){
      var index = $(this).data('index'),
        img_src = $(this).data('img-src'),
        value = $(this).val();
        qtyArray[index] = value;
        imgSrcArray[index] = img_src;
		imgRedrawl = $(this).data('redrawl');
    });
    //add images by index and quantity
    qtyArray.forEach(function(value, index){
    for(var i=0; i< value; i++){
      $('#selected-products').append('<li><img src="' + imgSrcArray[index] + '" alt="Blend image"></li>');
    }
  });
};

$(document).ready(function($) {
  //global variables
  var totalItems = 0,
   totalAmount = 0,
   unitPrice = $('.price-total').data('unit-price'),
   imgSrc = '';

  //quantity selector
  $('.quantity-control').on('click', function(e){
    e.preventDefault();
    var minVal = 0,
      maxVal = $(this).siblings('.option-quantity').attr('max'),
      input = $(this).siblings('.option-quantity'),
      dataType = $(this).attr('data-type'),
      currentVal = parseInt(input.val()),
      totalVal = 0,
      newVal = 0,
      imgSrc = input.data('img-src');

    $('.product-option').each(function(){
      var newVal = parseFloat($(this).find('.option-quantity').val());
      if(newVal){totalVal = parseFloat(totalVal + newVal);}
    });

    if(dataType == 'plus') {
      if(currentVal < maxVal){
        input.val(currentVal + 1).change();
        totalItems += 1;
      } else {
        alert('You have reached maximum available count for this product.');
      }
    }
    if(dataType == 'minus') {
      if(currentVal > minVal){
        input.val(currentVal - 1).change();
        totalItems -= 1;
      }
    }

    // update cart details
    $('.item-count').text(totalItems);
    $('.packs-count').text(totalItems * 10);
    $('.price-total').text("$" + totalItems * unitPrice);

    //update product images
    redraw_product_images();

    //check if minimum subscription items meets requirement
    if(totalItems < 4){
      $('a.cart-submit').attr("disabled", true);
      $('a.cart-submit').on("click", function (e) {
        e.preventDefault();
      });
      $('a.cart-submit').text('4 box minimum to subscribe');
    }  else {
      $('a.cart-submit').removeAttr("disabled");
      $('a.cart-submit').text('Subscribe');
    }
  });

  //call cart submit scripts
  $('a.cart-submit').on('click', function(e){
    e.preventDefault();
    if(totalItems < 4){
      // do nothing
        alert('Please select 4 box minimum to subscribe.');
    } else {
      // Queue array initiation put here to reset number of items in queue on every form submit
      Shopify.queue = [];

      //read each list item
      jQuery('.option-quantity').each(function() {
        //get variable values to push in queue
        var v_id = jQuery(this).data('product-id'),
          qty = parseInt(jQuery(this).val(), 10) || 0,
          shipping_frequency = jQuery('#shipping_frequency').find(":selected").val(),
          shipping_unit = jQuery(this).data('subscription-unit'),
          s_id = jQuery(this).data('subscription-id');

        //add item to the queue
        if(qty > 0){
          push_to_queue(v_id, qty, shipping_frequency, shipping_unit, s_id);
        }
      });
      if (Shopify.queue.length) {
        // process the queue
        Shopify.moveAlong();
      }
    }
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["create-your-blend"]) return;
  try {
    

Shopify.moveAlong = function () {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      // pass the properties into addItem as well
      Shopify.addItem(request.v_id, request.qty, request.shipping_frequency, request.shipping_unit, request.s_id, Shopify.moveAlong);
  }
  // If the queue is empty, we will redirect to the cart page.
  else {
      document.location.href = '/cart';
  }
};

// Create a new Shopify.addItem function that takes the 'properties' parameter
Shopify.addItem = function (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id, callback) {
  var params = {
    "quantity": quantity,
    "id": variant_id,
    "properties[shipping_interval_frequency]": shipping_interval_frequency,
    "properties[shipping_interval_unit_type]": shipping_interval_unit_type,
    "properties[subscription_id]": subscription_id
  };
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function () {
      if (typeof callback === 'function') {
        callback();
      }
    },
    error: function () {}
  });
}

function push_to_queue(v_id, qty, shipping_frequency, shipping_unit, s_id) {
  Shopify.queue.push({
    v_id: v_id,
    qty: qty,
    shipping_frequency: shipping_frequency,
    shipping_unit: shipping_unit,
    s_id: s_id
  });
}

function redraw_product_images(){
  //update product images
  $('#selected-products').empty();
  var imgSrc = imgSrc,
    qtyArray = [0,0,0,0],
    imgSrcArray = ['','','',''];

    $('.option-quantity').each(function(){
      var index = $(this).data('index'),
        img_src = $(this).data('img-src'),
        value = $(this).val();
        qtyArray[index] = value;
        imgSrcArray[index] = img_src;
		
    });
    //add images by index and quantity
    qtyArray.forEach(function(value, index){
    for(var i=0; i< value; i++){
      $('#selected-products').append('<li><img src="' + imgSrcArray[index] + '" alt="Blend image"></li>');
    }
  });
};

$(document).ready(function($) {
  //global variables
  var totalItems = 0,
   totalAmount = 0,
   unitPrice = $('.price-total').data('unit-price'),
   imgSrc = '';

  //quantity selector
  $('.option-control').on('click', function(e){
    e.preventDefault();
    var minVal = 0,
      maxVal = 1000,
      input = $(this).siblings('.option-quantity'),
      dataType = $(this).attr('data-type'),
      currentVal = parseInt(input.val()),
      totalVal = 0,
      newVal = 0,
      imgSrc = input.data('img-src');

    $('.product-option').each(function(){
      var newVal = parseFloat($(this).find('.option-quantity').val());
      if(newVal){totalVal = parseFloat(totalVal + newVal);}
    });
    if(totalVal < maxVal){
      if(dataType == 'plus') {
        if(currentVal < maxVal){
          input.val(currentVal + 1).change();
          totalItems += 1;
        }
      }
    }
    if(dataType == 'minus') {
      if(currentVal > minVal){
        input.val(currentVal - 1).change();
        totalItems -= 1;
      }
    }

    // update cart details
    $('.item-count').text(totalItems);
    $('.packs-count').text(totalItems * 10);
    $('.price-total').text("$" + totalItems * unitPrice);

    //update product images
    redraw_product_images();

    //check if minimum subscription items meets requirement
    if(totalItems < 4){
      $('a.cart-submit').attr("disabled", true);
      $('a.cart-submit').on("click", function (e) {
        e.preventDefault();
      });
      $('a.cart-submit').text('4 box minimum to subscribe');
    }  else {
      $('a.cart-submit').removeAttr("disabled");
      $('a.cart-submit').text('Subscribe');
    }
  });

  //call cart submit scripts
  $('a.cart-submit').on('click', function(e){
    e.preventDefault();
    if(totalItems < 4){
      // do nothing
        alert('Please select 4 box minimum to subscribe.');
    } else {
      // Queue array initiation put here to reset number of items in queue on every form submit
      Shopify.queue = [];

      //read each list item
      jQuery('.option-quantity').each(function() {
        //get variable values to push in queue
        var v_id = jQuery(this).data('product-id'),
          qty = parseInt(jQuery(this).val(), 10) || 0,
          shipping_frequency = jQuery('#shipping_frequency').find(":selected").val(),
          shipping_unit = jQuery(this).data('subscription-unit'),
          s_id = jQuery(this).data('subscription-id');

        //add item to the queue
        if(qty > 0){
          push_to_queue(v_id, qty, shipping_frequency, shipping_unit, s_id);
        }
      });
      if (Shopify.queue.length) {
        // process the queue
        Shopify.moveAlong();
      }
    }
  });

});


  } catch(e) { console.error(e); }
})();
})();
